<template>
  <div
    class="bg-primary-700 flex min-h-full justify-center items-center relative"
  >
    <div class="absolute top-8 right-8">
      <ProfileMenu avatar-class="size-8" />
    </div>
    <div class="max-w-[450px] w-full">
      <div class="bg-[#252929] p-6 rounded-lg">
        <div class="text-white text-lg mb-1">Pending Invitations</div>
        <p class="text-white/50">You have the following invitations</p>
        <PendingInvitationsView />
      </div>
      <p class="text-center mt-4">
        <router-link
          :to="{ name: 'workspace-projects' }"
          class="text-accent-400 hover:text-accent-300 hover:underline"
          >Back to workspace
        </router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import PendingInvitationsView from '@features/invitations/PendingInvitationsView.vue';
import ProfileMenu from '@components/board/ProfileMenu.vue';
</script>
